import { useRef } from "react";
import React from "react";
import RenderRoutes from "./components/RenderRoutes";
import { routes } from "./utils/routes";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Audio from "./components/Audio";
import AppContextProvider from "./context/AppContext";

const theme = createTheme({
  typography: {
    fontFamily: ["Orbitron", "Plus Jakarta Sans", "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppContextProvider>
        <ToastContainer />
        <Audio />
        <RenderRoutes routes={routes} />
      </AppContextProvider>
    </ThemeProvider>
  );
}

export default App;
